import { settingsApiRequest } from '../../screens/settings/settingsApi';

const handler = async ({ resource_name, changes }, { rejectWithValue }) => {
  try {
    const data = await settingsApiRequest({
      method: 'PUT',
      path: `/settings/article/${resource_name}`,
      body: changes, // only the fields that changed
    });
    return { article: data };
  } catch (error) {
    console.error('services.articles.updateArticle@handler', error);
    return rejectWithValue({ status: error.status, message: error.message });
  }
};

const pending = (state) => ({ ...state, updating: true });
const fulfilled = (state, action) => ({
  ...state,
  updating: false,
  lists: state.lists.map((a) =>
    a.resource_name === action.payload.article.resource_name ? action.payload.article : a
  ),
});
const rejected = (state) => ({ ...state, updating: false });

export default { handler, pending, fulfilled, rejected };
